import PortalIdParser from 'PortalIdParser';
import I18n from 'I18n';
import { DataSyncAuthModal } from 'ui-universal-auth/DataSyncAuthModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataSyncServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthSucceeded,
  reconnectStarted
}) => {
  const portalId = PortalIdParser.get();
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  const accountId = metadata === null || metadata === void 0 ? void 0 : metadata.accountId;
  const handleCancel = () => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
      message: I18n.text('reconnect.warnings.reconnectionCancelled')
    });
  };
  const handleComplete = account => {
    onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(`${account === null || account === void 0 ? void 0 : account.id}`);
  };
  return reconnectStarted && /*#__PURE__*/_jsx(DataSyncAuthModal, {
    appId: appId,
    accountId: Number(accountId),
    portalId: portalId,
    onComplete: handleComplete,
    onCancel: handleCancel
  });
};